import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import {
    BaseSearcherState,
    initialBaseSearcherState
} from '@/components/common/searcher/components/base/base-searcher.model'
import { SearcherStatus } from '@/components/common/searcher/shared/models/common-searcher.model'
import { PromiseUtils } from '@/shared/util/promise-utils'
import apiExceptionType from '@/utils/apiExceptionType'
import axios from 'axios'
import { StrictNullable } from '@/shared/types/app.types'

@Component
export default class BaseSearcher<P, T> extends Vue {
    @Prop({ type: Function, required: true }) readonly searcher!: (params: P) => Promise<T[]>

    @Emit()
    searchLoading(loading: boolean): boolean {
        return loading
    }
    @Emit()
    searchStatus(status: SearcherStatus): SearcherStatus {
        this.state.status = status
        return status
    }
    @Emit()
    searched(searchedData: T[]): T[] {
        return searchedData
    }

    state: BaseSearcherState
    constructor() {
        super()
        this.state = initialBaseSearcherState()
    }

    get searchDone(): boolean {
        return ![
            SearcherStatus.NO_SEARCH_DONE_YET,
            SearcherStatus.SEARCH_CLEARED
        ].includes(this.state.status)
    }

    ///

    mounted(): void {
        this.searchLoading(false) // emits an event
        this.searchStatus(this.state.status) // emits an event
    }

    ///

    protected async internalSearch(
        searcher: (params: P) => Promise<T[]>,
        params: P
    ): Promise<StrictNullable<T[]>> {
        this.searchLoading(true) // emits an event
        const response =
            await PromiseUtils.toCallSecure(
                this.searcher(params),
                error => {
                    if (!axios.isCancel(error)) {
                        if (axios.isAxiosError(error)) {
                            if (error.response?.data.code === apiExceptionType.RESULT_LIMIT_EXCEEDED) {
                                this.searchStatus(SearcherStatus.TOO_MANY_RESULTS) // emits an event
                                return
                            }
                        }
                        this.searchStatus(SearcherStatus.ERROR) // emits an event
                        console.error(error)
                    }
                })
        this.searchLoading(false) // emits an event
        return response
    }
}
